import React from "react";
import * as MUIColors from "@mui/material/colors";
import * as MUIIcons from "@mui/icons-material";
import MUIAvatar from "@mui/material/Avatar";
import MUIGreyColor from "@mui/material/colors/grey";

import MUICheckCircleIcon from "@mui/icons-material/CheckCircle";
import QueueRoute from "../../Utility/Crud/QueueRoute";

import Chip from "../Chip";
import MainContext from "../../Context/MainContext/MainContext";

export default class ChipQueueRoute extends Chip {
  static contextType = MainContext;

  renderAvatar() {
    // If selected, show white checkmark in a circle, else original avatar
    if (this.props.selected) {
      return (
        <MUIAvatar sx={{ bgcolor: "transparent" }}>
          <MUICheckCircleIcon
            fontSize="small"
            sx={{ color: (theme) => theme.palette.background.paper }}
          />
        </MUIAvatar>
      );
    } else {
      const orderStatusReason =
        this.context.orderStatusReasonsIndexed?.[
          this.props.queueRoute?.toOrderStatusReasonId
        ];

      const orderStatusId = orderStatusReason?.orderStatus;

      const orderStatus =
        orderStatusId !== null
          ? this.context.orderStatusesIndexed?.[orderStatusId]
          : null;
      const colorObject = orderStatus?.colorId
        ? this.context.colorsIndexed?.[orderStatus.colorId]
        : null;

      const color = colorObject
        ? MUIColors[colorObject.hue][colorObject.shade]
        : MUIGreyColor[500];
      const avatarColor = this.props.isTransparent ? "transparent" : color;
      const iconColor = this.props.isTransparent ? color : "#fff";

      const isBusinessSupportHelpRoute =
        this.props.queueRoute?.id === "request-business-support-help";
      const IconComponent = isBusinessSupportHelpRoute
        ? MUIIcons.QuestionMark
        : MUIIcons[QueueRoute.getIconName()];

      return (
        <MUIAvatar sx={{ bgcolor: avatarColor }}>
          {React.createElement(IconComponent, {
            fontSize: "small",
            sx: { color: iconColor },
          })}
        </MUIAvatar>
      );
    }
  }

  getLabel() {
    return this.props.queueRoute.name;
  }
}
